

/*----------------------------------------------------------
    IE
----------------------------------------------------------*/
if(navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
  $('body').on("mousewheel", function () {
    event.preventDefault();
    var wd = event.wheelDelta;
    var csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
  });
}

/*----------------------------------------------------------
    loading
----------------------------------------------------------*/
var LoadEnd=false;
jQuery.event.add(window,"load",function() {
    var target=$("#loading");
    setTimeout(function(){
      LoadEnd=true;
      $("body").addClass('pageLoad');
      target.addClass('out');
      //スクロール表示
      ScrollView_func();
      setTimeout(function(){
        target.hide();
        ScrollView_func()
      },1000);
      
    },500);
    
});


/*----------------------------------------------------------
init
----------------------------------------------------------*/
var WinScroll = 0;
var WinW = 0;
var WinH = 0;
var delayScroll=0;

(function() {
  $("body").addClass("loadStart");


  function init(){
    WinScroll = $(window).scrollTop();
    WinW = $(window).width();
    WinH = window.innerHeight ? window.innerHeight : $(window).height();
    
    /*言語切り替え
    ----------------------------------------------------------*/
    if($("html").attr("lang")=="en"){
      $("#negroni .block_header .lang a").text("JAPANESE");
      $("#negroni .block_header .lang a").attr("href","/?currency=jpy");
    }
    /*hash
    ----------------------------------------------------------*/
    if(location.hash){
      console.log(location.hash);
      $('html,body').stop().animate({ scrollTop:$(location.hash).offset().top-100},400, 'swing');
      //カテゴリーの場合
      if(location.hash.substr(0,9)=="#category"){
        $(location.hash).find(".category_contents").slideDown(400);
        $(location.hash).addClass("view");
      }
    }

    //アンカーリンク判定
    $('#negroni .block_navigation .inner .block a').each(function(index) {
      var target_url=$(this).attr("href").substr(0,10);
      var this_url=location.pathname.substr(0,10);
      if(target_url==this_url){
        var target_array=$(this).attr("href").split("#");
        var target_hash="#"+target_array[1];
        $(this).on("click", function (e) {
          $("body").removeClass("menu_open");
          $("body").css("overflow","auto");
          $('html,body').stop().animate({ scrollTop:$(target_hash).offset().top-100},400, 'swing');
          //カテゴリーの場合
          if(target_hash.substr(0,9)=="#category"){
            $(target_hash).find(".category_contents").slideDown(400);
            $(target_hash).addClass("view");
          }
        });
      }
    });

    /*scroll
    ----------------------------------------------------------*/
    $("#pagetop").find("a").on("click", function (e) {
      e.preventDefault();
      $('html,body').stop().animate({ scrollTop:0},800, 'swing');
    });
    
    $("#scroll").find("a").on("click", function (e) {
      e.preventDefault();
      $('html,body').stop().animate({ scrollTop:WinH},800, 'swing');
    });
    
    $("#negroni .block_prodcut_story_detail .inner .summary .btn_area a").on("click", function (e) {
      e.preventDefault();
      $('html,body').stop().animate({ scrollTop:$("#entry").offset().top},400, 'swing');
    });
    
    /*header
    ----------------------------------------------------------*/
    $('a.toggle').on("click", function (e) {
      e.preventDefault();
      if($("body").hasClass("menu_open")){
        $("body").removeClass("menu_open");
        $("body").css("overflow","auto");
      }else{
        $("body").addClass("menu_open");
        $("body").css("overflow","hidden");
      }
    });
    $('.block_navigation a.close').on("click", function (e) {
      e.preventDefault();
      if($("body").hasClass("menu_open")){
        $("body").removeClass("menu_open");
        $("body").css("overflow","auto");
      }else{
        $("body").addClass("menu_open");
        $("body").css("overflow","hidden");
      }
    });
    $('#negroni .block_navigation .inner .block dl.first > dt').on("click", function (e) {
      e.preventDefault();
      if($(this).hasClass("view")){
        $(this).removeClass("view");
        $(this).next().slideUp(400);
      }else{
        $(this).addClass("view");
        $(this).next().slideDown(400);
      }
    });
    if(WinW>896){
      $('#negroni .block_navigation .inner .block dl.first > dt.pc_open').addClass("view");
      $('#negroni .block_navigation .inner .block dl.first > dt.pc_open').next().slideDown(400);
    }
    $('#negroni .block_navigation .inner .block dl.first > dd dl.second dt').on("click", function (e) {
      e.preventDefault();
      if($(this).hasClass("view")){
        $(this).removeClass("view");
        $(this).next().slideUp(400);
      }else{
        $(this).addClass("view");
        $(this).next().slideDown(400);
      }
    });


    /*----------------------------------------------------------
      block_item_category_list
    ----------------------------------------------------------*/
    $('#negroni .block_item_category_list .inner .btn_close').show();
    $('#negroni .block_item_category_list .inner .category_area .category_header').on("click", function (e) {
      e.preventDefault();
      if($(this).parent().hasClass("view")){
        $(this).parent().removeClass("view");
        $(this).parent().find(".category_contents").slideDown(400);
      }else{
        $(this).parent().addClass("view");
        $(this).parent().find(".category_contents").slideUp(400);
      }
    });
    $('#negroni .block_item_category_list .inner .btn_close').on("click", function (e) {
      e.preventDefault();
      $('html,body').stop().animate({ scrollTop:0},800, 'swing');
      $('#negroni .block_item_category_list .inner .btn_close').hide();
      $('#negroni .block_item_category_list .inner .category_area').addClass("view");
      $('#negroni .block_item_category_list .inner .category_area .category_contents').slideUp(400);
    });

  /*----------------------------------------------------------
    top mainvisual
  ----------------------------------------------------------*/
  if($(".block_mainvisual .slide_area .column").length>1){
    $('.block_mainvisual .slide_area').slick({
      accessibility: false,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 800, 
      pauseOnHover: false, 
      pauseOnDotsHover: false,
      cssEase: 'ease', 
      dots: false,
      draggable: true,
      fade: false,
      arrows: false,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      vertical: false,
      centerMode: true,
      variableWidth: false,
      centerPadding: 0
    }).on('reInit init', function(event, slick, currentSlide, nextSlide){
      //console.log("reInit init : "+currentSlide);
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //console.log("beforeChange : "+currentSlide);
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
      var i = (currentSlide ? currentSlide : 0) + 1;
    })
  }
  /*----------------------------------------------------------
    FOCUS IN
  ----------------------------------------------------------*/
  if($("#focus_in.block_item_slide_list .inner .slide_area .column").length>1){
    if(WinW>=768){
      $('#focus_in.block_item_slide_list .inner .slide_area').slick({
        accessibility: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 800, 
        pauseOnHover: false, 
        pauseOnDotsHover: false,
        cssEase: 'ease', 
        dots: true,
        draggable: true,
        fade: false,
        arrows: true,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 3,
        swipe: true,
        vertical: false,
        centerMode: false,
        variableWidth: false,
        centerPadding: 0
      }).on('reInit init', function(event, slick, currentSlide, nextSlide){
        //console.log("reInit init : "+currentSlide);
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //console.log("beforeChange : "+currentSlide);
      }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
      })
    }else{
      $('#focus_in.block_item_slide_list .inner .slide_area').slick({
        accessibility: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 800, 
        pauseOnHover: false, 
        pauseOnDotsHover: false,
        cssEase: 'ease', 
        dots: true,
        draggable: true,
        fade: false,
        arrows: true,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        vertical: false,
        centerMode: false,
        variableWidth: false,
        centerPadding: 0
      }).on('reInit init', function(event, slick, currentSlide, nextSlide){
        //console.log("reInit init : "+currentSlide);
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //console.log("beforeChange : "+currentSlide);
      }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
      })
    }
  }
  
  /*----------------------------------------------------------
    画面スライド
  ----------------------------------------------------------*/
  if($(".block_image_slide_list .slide_area .column").length>1){
    $('.block_image_slide_list .slide_area').slick({
      accessibility: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 800, 
      pauseOnHover: false, 
      pauseOnDotsHover: false,
      cssEase: 'ease', 
      dots: true,
      draggable: true,
      fade: false,
      arrows: true,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      vertical: false,
      centerMode: false,
      variableWidth: false,
      centerPadding: 0
    }).on('reInit init', function(event, slick, currentSlide, nextSlide){
      //console.log("reInit init : "+currentSlide);
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //console.log("beforeChange : "+currentSlide);
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
      var i = (currentSlide ? currentSlide : 0) + 1;
    })
  }

  /*----------------------------------------------------------
    NEW IN
  ----------------------------------------------------------*/
  if($("#new_in.block_item_slide_list .inner .slide_area .column").length>1){
    $('#new_in.block_item_slide_list .inner .slide_area').slick({
      accessibility: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 800, 
      pauseOnHover: false, 
      pauseOnDotsHover: false,
      cssEase: 'ease', 
      dots: true,
      draggable: true,
      fade: false,
      arrows: true,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 4,
      swipe: true,
      vertical: false,
      centerMode: false,
      variableWidth: false,
      centerPadding: 0
    }).on('reInit init', function(event, slick, currentSlide, nextSlide){
      //console.log("reInit init : "+currentSlide);
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //console.log("beforeChange : "+currentSlide);
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
      var i = (currentSlide ? currentSlide : 0) + 1;
    })
  }
  

  /*----------------------------------------------------------
    商品詳細
  ----------------------------------------------------------*/
  if($(".block_item_detail .inner .summary .image_area ul li").length>1){
    $('.block_item_detail .inner .summary .image_area ul').slick({
      accessibility: false,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 800, 
      pauseOnHover: false, 
      pauseOnDotsHover: false,
      cssEase: 'ease', 
      dots: true,
      draggable: true,
      fade: false,
      arrows: true,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      vertical: false,
      centerMode: true,
      variableWidth: false,
      centerPadding: 0
    }).on('reInit init', function(event, slick, currentSlide, nextSlide){
      //console.log("reInit init : "+currentSlide);
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      //console.log("beforeChange : "+currentSlide);
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
      var i = (currentSlide ? currentSlide : 0) + 1;
    })
  }
  
  
  $('.block_item_detail .inner .entry .spec_column .column_header').on("click", function (e) {
    e.preventDefault();
    if($(this).hasClass("active")){
      $(this).removeClass("active");
      $(this).next().stop().slideUp(400);
    }else{
      $(this).addClass("active");
      $(this).next().slideDown(400);
    }
  });
  
  $('.block_textpage .ac_area .ac_header a').on("click", function (e) {
    e.preventDefault();
    if($(this).hasClass("active")){
      $(this).removeClass("active");
      $(this).parent().next().stop().slideUp(400);
    }else{
      $(this).addClass("active");
      $(this).parent().next().slideDown(400);
    }
  });
  
  $('.block_textpage ul.btn_area li a.ac_cont2_btn').on("click", function (e) {
    e.preventDefault();
    if($(this).hasClass("active")){
      $(this).removeClass("active");
      $(this).parent().parent().next().stop().slideUp(400);
    }else{
      $(this).addClass("active");
      $(this).parent().parent().next().slideDown(400);
    }
  });

  
  /*----------------------------------------------------------
    値段にカンマ
  ----------------------------------------------------------*/
  $('#negroni .block_item_category_list .inner .category_area .category_contents .price span').each(function(index) {
    var num=parseInt($(this).text());
    var cm_num=num.toLocaleString();
    $(this).text(cm_num);
  });
  
  /*----------------------------------------------------------
    商品一覧非表示対応
  ----------------------------------------------------------*/
  $('#negroni .block_item_category_list .inner .category_area').each(function(index) {
    if($(this).find(".category_header a").text()==""){
      $(this).hide();
    }
  });
  

  }//end :init


  /*----------------------------------------------------------
    scroll
  ----------------------------------------------------------*/
  function scroll_resize(){
    WinScroll = $(window).scrollTop();
    WinW = $(window).width();
    WinH = window.innerHeight ? window.innerHeight : $(window).height();

    ScrollView_func();
    
    /*scroll
    ----------------------------------------------------------*/
    if(WinScroll>10){
      $("body").addClass("onScroll");
    }else{
      $("body").removeClass("onScroll");
    }

    /*header
    ----------------------------------------------------------*/
    if(WinW>768){
      if(WinScroll>WinH){
        $("body").addClass("header_view");
      }else{
        $("body").removeClass("header_view");
      }
    }

    /*detail
    ----------------------------------------------------------*/
  if($(".block_item_detail .textarea .textarea_inner").length&&WinW>768){
    $(".block_item_detail .textarea").height($(".block_item_detail .inner").height())
    var target_width=$(".block_item_detail .textarea").width();
    var deg=(WinH-$("#header").height()-$(".block_item_detail .textarea .textarea_inner").height())*0.5
    var target_top=deg+$("#header").height();
    
    var first_pos=0;
    var end_pos=$("#product_list01").offset().top-WinH-15;

    if(WinScroll>first_pos&&WinScroll<end_pos){
      $(".block_item_detail .textarea .textarea_inner").css({"position":"fixed","width":target_width,"top":target_top,"bottom":"auto"})
    }else if(WinScroll<=first_pos){
      $(".block_item_detail .textarea .textarea_inner").css({"position":"fixed","width":target_width,"top":target_top,"bottom":"auto"})
    }else if(WinScroll>=end_pos){
      $(".block_item_detail .textarea .textarea_inner").css({"position":"absolute","width":target_width,"top":"auto","bottom":0});
    }
  }
    

  }

  $(window).on('load', init);
  $(window).on('orientationchange load scroll resize', scroll_resize);
})();

//scroll
function ScrollView_func(){
  // $('.split_text').each(function(index) {
  //   if(LoadEnd&&WinScroll>$(this).offset().top-WinH*0.9){
  //     var target=$(this);
  //     setTimeout(function(){
  //       target.addClass("view");
  //     },1000);
  //   }else{
  //     $(this).removeClass("view");
  //   }
  // });
  $('.scrollview').each(function(index) {
    if(LoadEnd&&WinScroll>$(this).offset().top-WinH*0.9){
      $(this).addClass("view");
    }else{
      $(this).removeClass("view");
    }
  });
  $('.scrollview_fix').each(function(index) {
    if(LoadEnd&&WinScroll>$(this).offset().top-WinH*0.9){
      $(this).addClass("view");
    }else{
      $(this).removeClass("view");
    }
  });
}

/*----------------------------------------------------------
transform
----------------------------------------------------------*/

function cssTransition(duration,delay,easing){
  var css = duration +'s '+ delay +'s '+easing;
  return {
    "-webkit-transition" : css,
    "-moz-transition"    : css,
    "-o-transition"      : css,
    "-ms-transition"     : css,
    "transition"         : css
  }
}

function cssTransformImage(x,y){
  var css = "scale3d(1.1,1.1,1.1) translate3d("+x+"px,"+y+"px,0px) rotate(-0deg)";
  return {
    "-webkit-transform" : css,
    "-moz-transform"    : css,
    "-o-transform"      : css,
    "-ms-transform"     : css,
    "transform"         : css
  }
}
function cssTransform(x,y){
  var css = "scale3d(1.2,1.2,1.2) translate3d("+x+"px,"+y+"px,0px) rotate(-0deg)";
  return {
    "-webkit-transform" : css,
    "-moz-transform"    : css,
    "-o-transform"      : css,
    "-ms-transform"     : css,
    "transform"         : css
  }
}
/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});